module.exports = __webpack_public_path__ + "static/media/40.fa15c207.jpg";